module.exports = __webpack_public_path__ + "static/cake_by_mehwish_logo-c4a57605910373454c0fe13b781404c2.png";